import { DEFAULT_ANIMATE_DURATION } from '@apeiron/temp'
import { styled } from '@mui/material'
import ApeironOperateButton, {
  ApeironOperateButtonProps
} from '@src/components/share/apeiron/ApeironOperateButton'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const Button = styled(ApeironOperateButton)`
  width: 119px;
  height: 37px;
  font-size: 14px;
  border-radius: 10px;
  background-color: #333536;
  color: #ffffff;
  text-transform: none;
  transition: filter ${DEFAULT_ANIMATE_DURATION}ms,
    background-color ${DEFAULT_ANIMATE_DURATION}ms;
  :active {
    filter: unset;
    background-color: #484a4a;
  }

  ${props => props.theme.breakpoints.up('res480')} {
    width: 167px;
    height: 43px;
    font-size: 16px;
    border-radius: 5px;
  }
`

const TradeUpdateSellButton: FC<ApeironOperateButtonProps> = (
  props: ApeironOperateButtonProps
) => {
  const { t } = useTranslation()

  return <Button {...props}>{t('trade.button.update_price')}</Button>
}

export default TradeUpdateSellButton
